import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'device_duration'

const OPTIONS = [
  {
    value: '1-3-days',
    translationKey: 'pages.onboarding.deviceDuration.options.1-3-days',
  },
  {
    value: '1-week',
    translationKey: 'pages.onboarding.deviceDuration.options.1-week',
  },
  {
    value: '2-weeks',
    translationKey: 'pages.onboarding.deviceDuration.options.2-weeks',
  },
  {
    value: '3-weeks',
    translationKey: 'pages.onboarding.deviceDuration.options.3-weeks',
  },
  {
    value: '1-month',
    translationKey: 'pages.onboarding.deviceDuration.options.1-month',
  },
  {
    value: 'more-than-1-month',
    translationKey: 'pages.onboarding.deviceDuration.options.more-than-1-month',
  },
]

const ANSWER_TEXTS = {
  '1-3-days': '1-3 days',
  '1-week': '1 week',
  '2-weeks': '2 weeks',
  '3-weeks': '3 weeks',
  '1-month': '1 month',
  'more-than-1-month': 'More than 1 month',
}

export default function DeviceDurationPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(ANSWER_TEXTS).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const answerValue = formData.get('answer') as string

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How long does a vape last you?',
      answer_key: answerValue,
      answer: ANSWER_TEXTS[answerValue as keyof typeof ANSWER_TEXTS],
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.deviceDuration.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
